module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-543.2c17b04.woff2";